import React, { useEffect, useState, useRef } from "react";
import styles from "../MyKohere/kohere.module.css";
import { MdCancel } from "react-icons/md";
import {
  updateTeamName,
  getTeamsByUserId,
  Teaminvite,
  deleteTeam,
  getTeamsMembersByTeamId,
} from "../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../Util/Toast";

const UpdateTeams = ({ teams, activeTab, setTeams }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editNameModalOpen, setEditNameModalOpen] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [newTeamName, setNewTeamName] = useState("");
  const [loading, setLoading] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const optionsRef = useRef(null);

  // Fetch team data based on activeTab
  useEffect(() => {
    const getTeamData = async () => {
      if (activeTab) {
        try {
          const response = await getTeamsByUserId(activeTab);
          if (response.data && response.status === 200) {
            const teamData = response.data.teams.find(
              (team) => team.teamId == activeTab
            );
            setSelectedTeam(teamData);
            setNewTeamName(teamData.teamName);
          }
        } catch (error) {
          console.error("Failed to fetch team details:", error);
        }
      }
    };

    getTeamData();
  }, [activeTab, teams]);

  // Fetch team members based on selected team
  useEffect(() => {
    const fetchTeamMembers = async () => {
      if (selectedTeam) {
        try {
          const response = await getTeamsMembersByTeamId(selectedTeam.teamId);
          if (response.status === 200 && response.data) {
            setTeamMembers(response.data.members); // Adjusted to match your data structure
          }
        } catch (error) {
          console.error("Failed to fetch team members:", error);
        }
      }
    };

    fetchTeamMembers();
  }, [selectedTeam]);

  // Handle click outside of options
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  // Options handling
  const handleOptionsClick = () => {
    setShowOptions(!showOptions);
  };

  const handleEditName = () => {
    setEditNameModalOpen(true);
    setShowOptions(false);
  };

  const handleDelete = async () => {
    const teamId = selectedTeam?.teamId;
    if (!teamId) return;

    try {
      const response = await deleteTeam(teamId);
      if (response.status === 200) {
        setTeams((prev) => prev.filter((item) => item.teamId !== teamId));
        SuccessSwal("Success", "Team deleted successfully!");
        setSelectedTeam(null);
      } else {
        warningSwal("Error", "Failed to delete the team.");
      }
    } catch (error) {
      console.error("Error deleting the team:", error);
      warningSwal("Error", "An error occurred while deleting the team.");
    }
  };

  // Handle saving the team name change
  const handleSaveNameChange = async (key) => {
    const teamId = selectedTeam?.teamId;
    const body = { teamName: newTeamName };

    if (!body.teamName.trim()) {
      warningSwal("Error", `Please provide a valid ${key} to update`);
      return;
    }

    try {
      const response = await updateTeamName(teamId, body);
      if (response.status === 200) {
        setSelectedTeam((prev) => ({ ...prev, teamName: newTeamName }));
        setEditNameModalOpen(false);
        SuccessSwal("Success", `${response.data.message}`);
      } else {
        warningSwal(
          "Error",
          `Failed to update ${key}: ${response.data.message}`
        );
      }
    } catch (error) {
      warningSwal(
        "Error",
        error.response?.data?.message ||
          `An error occurred while updating ${key}. Please try again.`
      );
    }
  };

  // Invite new team member
  const handleUpdateTeam = async () => {
    const teamId = selectedTeam?.teamId;
    const body = { teamId, email: inviteEmail.trim() };

    setLoading(true); // Start loading
    try {
      const response = await Teaminvite(body);
      if (response.status === 200) {
        SuccessSwal("Success", "Invitation sent successfully!");
        setInviteEmail("");
        setIsModalOpen(false);
      } else {
        warningSwal("Error", "Failed to send invitation.");
      }
    } catch (error) {
      warningSwal(
        "Error",
        error.response?.data?.message ||
          "An error occurred while sending the invitation."
      );
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <div className={styles.UpdateTeamscontainer}>
      <div className={styles.UpdateTeamsheader}>
        <h2 onClick={handleOptionsClick} style={{ cursor: "pointer" }}>
          {selectedTeam?.teamName} :
        </h2>
        <button
          className={styles.UpdateTeamsinviteButton}
          onClick={() => setIsModalOpen(true)}
        >
          Invite a Team Member
        </button>
      </div>

      {showOptions && (
        <div className={styles.optionsList} ref={optionsRef}>
          <ul>
            <li onClick={handleEditName}>Edit Name</li>
            <li onClick={handleDelete}>Delete</li>
          </ul>
        </div>
      )}

      <div className={styles.UpdateTeamMembers}>
        <table>
          <thead>
            <tr>
              {/* <th>Name</th> */}
              <th>Email</th>
              {/* <th>Mobile Number</th> */}
              <th>Invitation Status</th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {teamMembers && teamMembers.length > 0 ? (
              teamMembers.map((member) => (
                <tr key={member.memberId}> {/* Adjusted key */}
                  {/* <td>{member.name || "-"}</td> */}
                  <td>{member.email}</td>
                  {/* <td>{member.mobileNumber || "-"}</td> */}
                  <td>{member.inviteStatus}</td> {/* Adjusted to match your data */}
                  <td>{member.role || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No team members available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal for inviting team members */}
      {isModalOpen && (
        <div className={styles.UpdateTeamMembersmodalOverlay}>
          <div className={styles.UpdateTeamMembersmodal}>
            <div className={styles.UpdateTeamMembersmodalActions}>
              <h3>Invite a Team Member</h3>
              <button
                className={styles.UpdateTeamMemberscloseButton}
                onClick={() => setIsModalOpen(false)}
              >
                <MdCancel />
              </button>
            </div>
            <input
              type="email"
              placeholder="Invitee Email"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
            />
            <button
              className={styles.UpdateTeamMembersinviteButton}
              onClick={handleUpdateTeam}
              disabled={loading}
            >
              {loading ? "Inviting..." : "Invite"}
            </button>
          </div>
        </div>
      )}

      {/* Modal for editing team name */}
      {editNameModalOpen && (
        <div className={styles.UpdateTeamMembersmodalOverlay}>
          <div className={styles.UpdateTeamMembersmodal}>
            <div className={styles.UpdateTeamMembersmodalActions}>
              <h3>Edit Team Name</h3>
              <button
                className={styles.UpdateTeamMemberscloseButton}
                onClick={() => setEditNameModalOpen(false)}
              >
                <MdCancel />
              </button>
            </div>
            <input
              type="text"
              value={newTeamName}
              onChange={(e) => setNewTeamName(e.target.value)}
            />
            <button
              className={styles.UpdateTeamMembersinviteButton}
              onClick={() => handleSaveNameChange("team name")}
            >
              Save Changes
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateTeams;
